import { AnchorNavigationEvents } from '@frontend/utils/AnchorNavigationUtil';
import getComponentInstanceFor from '@swey/vue-hydration/getComponentInstanceFor';
import Modal from '@components/013-Modal/Modal.client';

export default class ShopList {
	private readonly element: HTMLElement;

	public static domSelectors = {
		modal: '.c-modal',
		trigger: '.m-shop-list__trigger',
		item: '.m-shop-list-item'
	};

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		document.addEventListener(AnchorNavigationEvents.change, this.anchorLinkHandler.bind(this));

		const allTriggers = this.element.querySelectorAll(ShopList.domSelectors.trigger);

		allTriggers.forEach((trigger: Element): void => {
			trigger.addEventListener('click', this.triggerHandler.bind(this));
		});
	}

	private triggerHandler(event: Event): void {
		const targetElement = event.target as HTMLElement;
		const parentElement = targetElement.closest(ShopList.domSelectors.item) as HTMLElement;
		this.openModalInElement(parentElement);
	}

	protected anchorLinkHandler(event: CustomEventInit): void {
		const targetElement = this.element.querySelector(event.detail.target);

		if (targetElement) {
			this.openModalInElement(targetElement);
		}
	}

	private openModalInElement(element: HTMLElement): void {
		const modalElement = element.querySelector(ShopList.domSelectors.modal) as HTMLElement;

		if (modalElement) {
			const modalComponent = getComponentInstanceFor(modalElement) as Modal;
			modalComponent.openModal();
		}
	}
}
